import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import App from './App.vue'
import VueCookies from 'vue-cookies'
import './assets/styles/_index.scss'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import i18n from './i18n'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/pl'
import { BadgePlugin, ButtonPlugin, CardPlugin, CollapsePlugin, FormCheckboxPlugin, FormGroupPlugin, FormRadioPlugin, ModalPlugin, PopoverPlugin, TabsPlugin, ToastPlugin, TooltipPlugin } from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
// import JsonCSV from 'vue-json-csv'

import Login from './components/Auth/Login.vue'
import Logout from './components/Auth/Logout.vue'
import Registration from './components/Auth/Registration.vue'
import AccountInactive from './components/Auth/AccountInactive.vue'
import AccountVerification from './components/Auth/AccountVerification.vue'
import AccountActive from './components/Auth/AccountActive.vue'
import PasswordRecover from './components/Auth/PasswordRecover.vue'
import PasswordReset from './components/Auth/PasswordReset.vue'
import PasswordResetConfirm from './components/Auth/PasswordResetConfirm.vue'
import Projects from './components/Projects/Projects.vue'
import ProjectCreate from './components/Projects/ProjectCreate.vue'
import ProjectShow from './components/Projects/ProjectShow.vue'
import Sources from './components/Sources/Sources.vue'
import SourcePreview from './components/Sources/SourcePreview.vue'
import SourceShow from './components/Sources/SourceShow.vue'
import SourceCreate from './components/Sources/SourceCreate.vue'
import SourceEdit from './components/Sources/SourceEdit.vue'
import Products from './components/Products/Products.vue'
import Feeds from './components/Feeds/Feeds.vue'

import FeedCreate from './components/Feeds/FeedCreate.vue'
import FeedEdit from './components/Feeds/FeedEdit.vue'
import MainSettings from './components/Feeds/Partials/MainSettings.vue'
import FieldMapping from './components/Feeds/Partials/FieldMapping.vue'
import Rules from './components/Feeds/Partials/Rules.vue'
import Filters from './components/Feeds/Partials/Filters.vue'
import Tagging from './components/Feeds/Partials/Tagging.vue'
import Preview from './components/Feeds/Partials/Preview.vue'
import Finish from './components/Feeds/Partials/Finish.vue'
import Details from './components/Feeds/Partials/Details.vue'

import Settings from './components/Settings.vue'
import Help from './components/Help.vue'
import Error from './components/Error.vue'
import NotFound from './components/NotFound.vue'

moment.locale('pl')

Vue.use(VueMoment, { moment })
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(VueSidebarMenu)
Vue.use(VueCookies)
Vue.use(BadgePlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(CollapsePlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormRadioPlugin)
Vue.use(ModalPlugin)
Vue.use(PopoverPlugin)
Vue.use(TabsPlugin)
Vue.use(ToastPlugin)
Vue.use(TooltipPlugin)
Vue.use(VueClipboard)
// Vue.component('downloadCsv', JsonCSV)

axios.defaults.headers.common.Authorization = 'Bearer ' + Vue.$cookies.get('access_token')

const routes = [
  { path: '/', name: 'home', component: Login },
  { path: '/login', name: 'auth.login', component: Login },
  { path: '/logout', name: 'auth.logout', component: Logout },
  { path: '/register', name: 'auth.register', component: Registration },
  { path: '/account-inactive', name: 'auth.account-inactive', component: AccountInactive, props: true },
  { path: '/activate/:token', name: 'auth.account-verification', component: AccountVerification },
  { path: '/account-active', name: 'auth.account-active', component: AccountActive },
  { path: '/password-recover', name: 'auth.password-recover', component: PasswordRecover },
  { path: '/password-reset', name: 'auth.password-reset', component: PasswordReset },
  { path: '/reset/:token', name: 'auth.password-reset-confirm', component: PasswordResetConfirm },
  { path: '/projects', name: 'projects', component: Projects },
  { path: '/project/create', name: 'project.create', component: ProjectCreate },
  { path: '/project/:id', name: 'project.show', component: ProjectShow },
  { path: '/project/:id/sources', name: 'sources', component: Sources },
  { path: '/project/:projectId/sources/create', name: 'source.create', component: SourceCreate },
  { path: '/project/:projectId/sources/preview', name: 'source.preview', component: SourcePreview, props: true },
  { path: '/project/:projectId/sources/:sourceId/show', name: 'source.show', component: SourceShow },
  { path: '/project/:projectId/sources/:sourceId/edit', name: 'source.edit', component: SourceEdit },
  { path: '/project/:id/products', name: 'products', component: Products },
  { path: '/project/:id/feeds', name: 'feeds', component: Feeds },
  { path: '/project/:id/feeds/:feedId/details', name: 'feed.details', component: Details, props: true, meta: { heading: 'Szczegóły' } },
  {
    path: '/project/:projectId/feeds/create',
    name: 'feed.create',
    component: FeedCreate,
    children: [
      {
        path: 'main-settings',
        name: 'feed.create.main-settings',
        component: MainSettings,
        props: true,
        meta: { heading: i18n.t('feeds.add_new_feed') }
      },
      {
        path: 'field-mapping',
        name: 'feed.create.field-mapping',
        component: FieldMapping,
        props: true,
        meta: { heading: i18n.t('feeds.field_mapping') }
      },
      {
        path: 'rules',
        name: 'feed.create.rules',
        component: Rules,
        props: true,
        meta: { heading: i18n.t('feeds.rules') }
      },
      {
        path: 'filters',
        name: 'feed.create.filters',
        component: Filters,
        props: true,
        meta: { heading: i18n.t('feeds.filters') }
      },
      {
        path: 'tagging',
        name: 'feed.create.tagging',
        component: Tagging,
        props: true,
        meta: { heading: i18n.t('feeds.tagging') }
      },
      {
        path: 'preview',
        name: 'feed.create.preview',
        component: Preview,
        props: true,
        meta: { heading: i18n.t('global.preview') }
      },
      {
        path: 'finish',
        name: 'feed.create.finish',
        component: Finish,
        props: true,
        meta: { heading: i18n.t('global.save') }
      }
    ],
    props: true
  },
  {
    path: '/project/:projectId/feeds/:feedId/edit',
    name: 'feed.edit',
    component: FeedEdit,
    children: [
      {
        path: 'field-mapping',
        name: 'feed.edit.field-mapping',
        component: FieldMapping,
        props: true,
        meta: { heading: i18n.t('feeds.field_mapping') }
      },
      {
        path: 'rules',
        name: 'feed.edit.rules',
        component: Rules,
        props: true,
        meta: { heading: i18n.t('feeds.rules') }
      },
      {
        path: 'filters',
        name: 'feed.edit.filters',
        component: Filters,
        props: true,
        meta: { heading: i18n.t('feeds.filters') }
      },
      {
        path: 'tagging',
        name: 'feed.edit.tagging',
        component: Tagging,
        props: true,
        meta: { heading: i18n.t('feeds.tagging') }
      },
      {
        path: 'preview',
        name: 'feed.edit.preview',
        component: Preview,
        props: true,
        meta: { heading: i18n.t('global.preview') }
      },
      {
        path: 'finish',
        name: 'feed.edit.finish',
        component: Finish,
        props: true,
        meta: { heading: i18n.t('global.save') }
      }
    ],
    props: true
  },
  { path: '/settings', name: 'settings', component: Settings },
  { path: '/help', name: 'help', component: Help },
  { path: '/error', name: 'auth.error', component: Error, props: true },
  { path: '/:catchAll(.*)', name: 'not-found', component: NotFound }
]

const router = new VueRouter({
  mode: 'history',
  base: '/app',
  routes: routes,
  scrollBehavior () {
    setTimeout(function () {
      window.scroll({ top: 0 })
    }, 100)
  }
})

router.beforeEach((to, from, next) => {
  const routeName = to.name!
  if ((!routeName.includes('auth')) && (Vue.$cookies.get('access_token') !== null)) next()
  else {
    if (routeName.includes('auth')) next()
    else next({ name: 'auth.login' })
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
